export default __webpack_public_path__ + "static/media/broken-tooth.492b1de6.svg";